export default function (f, c, pxRatio) {
  c.save()
  c.translate(f.x - (f.s / 2), f.y - (f.s / 2))
  c.rotate(f.a)
  c.beginPath()
  c.moveTo(0, -f.s)
  c.lineTo(0, 0.3 * f.s)
  c.moveTo(-0.3 * f.s, -0.2 * f.s)
  c.lineTo(0, 0.3 * f.s)
  c.lineTo(0.3 * f.s, -0.2 * f.s)
  c.lineWidth = f.w + pxRatio
  c.strokeStyle = 'black'
  c.stroke()
  c.beginPath()
  c.moveTo(0, -f.s)
  c.lineTo(0, 0.3 * f.s)
  c.moveTo(-0.3 * f.s, -0.2 * f.s)
  c.lineTo(0, 0.3 * f.s)
  c.lineTo(0.3 * f.s, -0.2 * f.s)
  c.lineWidth = f.w
  c.strokeStyle = f.color
  c.stroke()
  c.restore()
}



// WEBPACK FOOTER //
// ./src/assets/fleche.js